module.exports = __webpack_public_path__ + "images/ds-lda-bg-bottom-banner.webp";